/**
 * External dependencies
 */
import React, { useEffect, useState } from 'react';
import { Box, Text, Stack } from '@towersystems/towersystems-design-system';
import { connect } from 'react-redux';
import { get, map, set } from 'lodash';

/**
 * Internal dependencies
 */
import FormLabel from 'components/forms/form-label';
import FormTextInput from 'components/forms/form-text-input';
import FormSelect from 'components/forms/form-select';
import FormMultiCheckbox from 'components/forms/form-multi-checkbox';
import { editConnectionSalesTypes, saveConnectionSalesTypes } from 'state/connection-sales-types/actions';
import { getAllConnectionSalesTypes } from 'state/connection-sales-types/selectors';

/**
 * Style dependencies
 */
import './styles.scss';

const SalesTypesForm = ({ salesTypeId, connectionSalesTypes, retailerSalesTypes, retailerPaymentTypes, webPaymentTypes, connectionId, connectionType, disabled, ...props }) => {
    const handleOnChange = (name, value) => {
        // props.editConnectionSalesTypes(salesTypeId, {
        //     [name]: value,
        // });
        let a = {
			...values,
		};
		a[name] = value;
		setValues(a)

        props.editConnectionSalesTypes(salesTypeId, {
            [name]: value,
        });
    };

    const [values, setValues] = useState({
        web_payment_code: '',
		web_payment_type: '',
        retailer_sales_type: '',
        retailer_payment_type: '',
	});


    const handleOnChangeDD= (e) => {
        let a = {
			...values,
		};
		a[e.target.name] = e.target.value;
		setValues(a);

        props.editConnectionSalesTypes(salesTypeId, {
            [e.target.name]: e.target.value,
        });
    };

    const handleOnSubmit = async (e) => {
        e.preventDefault();
        props.beforeSubmit && props.beforeSubmit(connectionSalesTypes);

        let a = {
			...values,
		};

        a['connection_id'] = connectionId;
        a['web_payment_type'] = get(values, 'web_payment_type') ? get(values, 'web_payment_type') : (get(connectionSalesTypes, 'web_payment_type'));
        a['web_payment_code'] = get(values, 'web_payment_code') ? get(values, 'web_payment_code') : (get(connectionSalesTypes, 'web_payment_code'));
        a['retailer_sales_type'] = get(values, 'retailer_sales_type') ? get(values, 'retailer_sales_type') : (get(connectionSalesTypes, 'retailer_sales_type'));
        a['retailer_payment_type'] = get(values, 'retailer_payment_type') ? get(values, 'retailer_payment_type') : (get(connectionSalesTypes, 'retailer_payment_type'));

        try {
            let response = await props.saveConnectionSalesTypes(salesTypeId, a);
            props.afterSuccessfullSubmit && props.afterSuccessfullSubmit(response);
            // props.loadSalesTypesData(connectionId);
        } catch (error) {}

        props.afterSubmit && props.afterSubmit();
    };

    const isShown = disabled ? 'none' : 'block';

    return (
        <form id='sales-type-form' onSubmit={handleOnSubmit}>
            <Stack space='large'>
                <Box>
                    <FormLabel>Web Payment Type:</FormLabel>
                    <Text size='xsmall'>Web Payment Type.</Text>
                    {(connectionType == 'woo_commerce' || connectionType == 'big_commerce') && (webPaymentTypes!==null) ? (
                    <FormSelect
                        onChange={handleOnChangeDD}
                        name='web_payment_type'             
                        value={get(values, 'web_payment_type') ? get(values, 'web_payment_type') : (get(connectionSalesTypes, 'web_payment_type'))}
                    >
                        <option value='' />,
                        {map(webPaymentTypes, (webPaymentType) => (
                            <option value={webPaymentType.payment_type} key={webPaymentType.payment_id}>
                                {webPaymentType.payment_type} ({webPaymentType.payment_id})
                            </option> : ''
                        ))}

                    </FormSelect>) : (<FormTextInput
                        name='web_payment_type'
                        value={get(values, 'web_payment_type') ? get(values, 'web_payment_type') : get(connectionSalesTypes, 'web_payment_type')}
                        onChange={(e) => handleOnChange(e.target.name, e.target.value)}
                    />)}
                </Box>
                {(connectionType == 'shopify_graphql') ? (
                <Box>
                    <FormLabel>Web Payment Type Code:</FormLabel>
                    <Text size='xsmall'>Web Payment Type Code.</Text>
                    <FormTextInput
                        name='web_payment_code'
                        value={get(values, 'web_payment_code') ? get(values, 'web_payment_code') : get(connectionSalesTypes, 'web_payment_code')}
                        onChange={(e) => handleOnChange(e.target.name, e.target.value)}
                    />
                </Box>) : null}
                <Box display={isShown}>
                    <FormLabel>Retailer Sales Type:</FormLabel>
                    <Text size='xsmall'>Retailer Sales Type.</Text>
                    <FormSelect
                        onChange={handleOnChangeDD}
                        name='retailer_sales_type'             
                        value={get(values, 'retailer_sales_type') ? get(values, 'retailer_sales_type') : (get(connectionSalesTypes, 'retailer_sales_type'))}
                    >
                        <option value='' />,
                        {map(retailerSalesTypes, (retailerSalesType) => (
                            <option value={retailerSalesType} key={retailerSalesType}>
                                {retailerSalesType}
                            </option> : ''
                        ))}

                    </FormSelect>
                </Box>
                <Box>
                    <FormLabel>Retailer Payment Method:</FormLabel>
                    <Text size='xsmall'>
                        Retailer Payment Method
                    </Text>
                    <Box marginTop='medium'>
                        <FormSelect
                            onChange={handleOnChangeDD}
                            name='retailer_payment_type'             
                            value={get(values, 'retailer_payment_type') ? get(values, 'retailer_payment_type') : (get(connectionSalesTypes, 'retailer_payment_type'))}
                        >
                            <option value='' />,
                            {map(retailerPaymentTypes, (retailerPaymentType) => (
                                <option value={retailerPaymentType.pay_name} key={retailerPaymentType.id}>
                                    {retailerPaymentType.pay_name}
                                </option> : ''
                            ))}

                        </FormSelect>
                    </Box>
                </Box>
            </Stack>
        </form>
    );
};

export default connect(
    (state, ownProps) => ({
        //connectionSalesTypes: getAllConnectionSalesTypes(state),
    }),
    {
        editConnectionSalesTypes,
        saveConnectionSalesTypes,
    },
)(SalesTypesForm);
